import React, { useEffect, useState } from 'react'
import ModalDialog from '../../../components/layouts/ModalDialog'
import OrderStatus from '../../../components/partials/OrderStatus'
import UserIcon from '../../../components/elements/icons/UserIcon'
import DataTable from '../../../components/elements/DataTable'
import { authHeader, tableHeadersFields, transactionTimeStamp, baseUrl } from '../../../utils'
import { fetchPayments } from '../../../store/actions/paymentsActions'
import ArrowUpTrayIcon from '../../../components/elements/icons/ArrowUpTrayIcon'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../components/elements/Loader'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../../components/elements/icons/ArrowIcon'
import ValidatePayment from '../../../components/partials/payments/ValidatePayment'
import { PAYMENTS_ERROR, SET_SUCCESS } from '../../../store/types'
import axios from 'axios'
// import Filters from '../../../components/elements/Filters'

const Payments = () => {
    const [transactionDialogOpen, setTransactionDialogOpen] = useState(false)
    const [activeDialogTransaction, setActiveDialogTransaction] = useState(null)
    const paymentsSelector = useSelector((state => state.payments))
    const dispatch = useDispatch()

    const [perPage, setPerPage] = useState(25)
    const [currentPage, setCurrentPage] = useState(1)

    const updatePerPage = (count) => {
        setPerPage(count)
    }

    const updateCurrentPage = (count) => {
        setCurrentPage(count)
    }

    const [reload, setReload] = useState(0);

    useEffect (() => {
        
        dispatch(fetchPayments('', currentPage, perPage))
    }, [perPage, currentPage, dispatch, reload])

    const TransactionLink = ({reference, index}) => {
        return (
            <button className='text-gray-500 font-medium' onClick={() => {openTransaction(index)}}>{reference}</button>
        )
    }
    
    const TransactionAmount = ({amount}) => {
        return (<p className="font-medium">N {(amount/100).toLocaleString() || 0}</p>)
    }

    const transactionColumnWidths = {
        reference: 'w-2/12',
        paymentFor: 'w-3/12',
        status: 'w-1/12',
        paidBy: 'w-2/12',
        amount: 'w-1/12',
        timeStamp: 'w-2/12',
        '': 'w-1/12'
    }

    const cleanupData = (dataSet) => {
        const data = []
    
        dataSet.forEach((item, itemIndex) => {
            data.push(
                {
                    reference: <TransactionLink reference={item.transaction.transactionReference} index={itemIndex} />,
                    paymentFor: <p>{item.fee ? `${item.fee?.name}: ${item.application?.applicationCode}` : item?.invoiceAssignment?.invoiceName}</p>,
                    status: <OrderStatus status={item.transaction.status} />,
                    paidBy: <div><p>{item.createdBy?.name || ''}</p><p className='text-sm text-gray-500 number'>
                        {item?.createdBy?.email || ''}
                    </p></div>,
                    amount: <TransactionAmount amount={item?.fee?.amount ?  item?.fee?.amount : item?.invoiceAssignment?.amountPaid || 0} />,
                    timeStamp: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
                    '': item.applied ? 
                    <> 
                        <span className={`inline-block text-xs px-2 py-1 rounded bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize`}>Used</span>
                    </> 
                    : 
                    <div className='flex items-center gap-x-[5px]'>
                        <span className={`inline-block text-xs px-2 py-1 rounded bg-green-500 text-green-800 bg-opacity-10 font-outfit capitalize`}>Unused</span>
                        <button 
                            onClick={()=>{dispatch(applyPayment(item._id))}} 
                            className='flex items-center gap-x-[5px] bg-green-600 p-[5px] rounded transition duration-200 text-white hover:bg-green-800'
                            disabled={paymentsSelector.applyingPayment === item._id}
                        >
                            {applying === item._id ? 
                                'applying...' 
                                : 
                                <span className='flex items-center gap-x-[5px]'>
                                    Apply<ArrowIcon className={`w-4 h-4`} />
                                </span>
                            }
                        </button>
                    </div>
                },
            )
        })
    
        return data
    }

    const [applying, setApplying] = useState(null);
    const applyPayment = (paymentId) => async (dispatch) => {    
        try{
            const headers = authHeader()
            console.log('the payment being applied', paymentId)
            setApplying(paymentId)
            setReload(reload+1)
            await axios.get(`${baseUrl}/payments/apply/${paymentId}`, { headers })
            
            dispatch({
                type: SET_SUCCESS,
                payload: 'payment applied successfully!'
            })
            setApplying(null)
            setReload(reload+2)
            
        }
        catch(error){
            dispatch({
                type: PAYMENTS_ERROR,
                error
            })
        }
    }

    const openTransaction = (transactionIndex) => {
        setTransactionDialogOpen(true)
        setActiveDialogTransaction(transactionIndex)
        console.log(transactionDialogOpen)
        console.log(activeDialogTransaction)
    }

    // const closeTransaction = () => {
    //     setTransactionDialogOpen(false)
    //     setActiveDialogTransaction(null)
    // }
    
    const tableOptions = {
        selectable: false,
        clickableRows: true,
        rowAction: (index)=>{}
    }

    const columnDataStyles = {}

    // eslint-disable-next-line no-unused-vars
    const [selectedUsersCount, setSelectedUsersCount] = useState(0)

    const getSelectionCount = (count) => {
        return setSelectedUsersCount(count)
    }

    const [validatingPayment, setValidatingPayment] = useState(false);

    return (
        <>
            <div className="w-full">
                <div className='py-3 mb-2'>
                    <div className="w-full mx-auto">
                        <div className='w-full flex items-center justify-between'>
                            <div className='w-2/3'>
                                <h4 className='font-medium text-lg mb-1 text-gray-400'>Payments</h4>
                                <div className=''>
                                    <p className='text-gray-500 mt-1 text-sm'>
                                        Below is a list of payments to Vaatia College
                                    </p>
                                </div>
                            </div>
                            <button onClick={()=>{setValidatingPayment(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                Record/Validate a payment
                            </button>
                        </div>

                        <div className='w-full flex items-center justify-between my-2 p-2 rounded-md border'>
                            {/* <div className='w-full'>
                                <Filters />
                            </div> */}
                            <div className='w-full flex flex-row-reverse gap-x-2'>
                                <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                                    <ArrowUpTrayIcon className={`w-5 h-5`} />
                                    Export payments
                                </button>
                                
                                {/* <button onClick={()=>{setView('grid')}} className={`${view === 'grid' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                                    <SquaresIcon className={`w-7 h-7`} />
                                </button>

                                <button onClick={()=>{setView('list')}} className={`${view === 'list' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                                    <ViewListIcon className={`w-7 h-7`} />
                                </button> */}
                            </div>
                        </div>
                    </div>


                </div>

                <div className=''>
                    {paymentsSelector.loadingPayments 
                        ? 
                            <div className='w-full'>
                                <Loader />
                            </div>
                        : 
                            <DataTable
                                tableHeaders={tableHeadersFields(cleanupData(paymentsSelector.payments.payments)[0]).headers} 
                                tableData={cleanupData(paymentsSelector.payments.payments)} 
                                columnWidths={transactionColumnWidths}
                                columnDataStyles={columnDataStyles}
                                allFields={tableHeadersFields(cleanupData(paymentsSelector.payments.payments)[0]).fields}
                                onSelectItems={getSelectionCount}
                                tableOptions={tableOptions}
                                pagination={{
                                    perPage, 
                                    currentPage,
                                    totalItems: paymentsSelector.payments.total,
                                }}
                                changePage={updateCurrentPage}
                                updatePerPage={updatePerPage}
                            />
                    }
                </div>
            </div>

            {/* <Transition appear show={transactionDialogOpen} as={Fragment}> */}
            {activeDialogTransaction && <ModalDialog
                shown={transactionDialogOpen} 
                closeFunction={()=>{setTransactionDialogOpen(false)}} 
                actionFunction={()=>{}} 
                dialogTitle='Transaction Details'
                maxWidthClass='max-w-md'
            >
                <div className="mt-2">
                    <div className='w-full flex flex-row justify-between py-3 border-b border-secondary'>
                        <div className="w-1/2">
                            <label className='text-xs block mb-3 text-opacity-40'>Reference</label>
                            <p className="text-xs font-medium">
                                {paymentsSelector?.payments?.payments[activeDialogTransaction]?.transaction?.transactionReference}
                            </p>
                        </div>
                        <div className="w-1/2"> 
                            <label className='text-xs block mb-2 text-opacity-40'>Status</label>
                            <div className='flex flex-row items-center gap-x-2'>
                                <OrderStatus status={paymentsSelector?.payments?.payments[activeDialogTransaction]?.transaction?.status} />
                            </div>
                        </div>
                    </div>

                    <div className='w-full flex flex-row py-3 border-b border-secondary'>
                        <div className="w-1/2">
                            <label className='text-xs block mb-3 text-opacity-40'>Time stamp</label>
                            <p className="text-xs font-medium">
                            {transactionTimeStamp(paymentsSelector?.payments?.payments[activeDialogTransaction]?.createdAt)?.date} - {transactionTimeStamp(paymentsSelector.payments.payments[activeDialogTransaction]?.createdAt).time}
                            </p>
                        </div>
                        <div className="w-1/2">
                            <label className='text-xs block mb-2 text-opacity-40'>Amount</label>
                            <p className="font-medium text-xl text-gray-700">N {paymentsSelector?.payments?.payments[activeDialogTransaction]?.fee?.amount ? (paymentsSelector?.payments?.payments[activeDialogTransaction]?.fee?.amount/100)?.toLocaleString() : 0 }</p>
                        </div>
                    </div>

                    <div className='w-full flex flex-row py-3 border-b border-secondary'>
                        <div className="w-1/2">
                            <label className='text-xs block mb-3 text-opacity-40'>Payment for</label>
                            <p className="text-xs font-medium">
                             {paymentsSelector?.payments?.payments[activeDialogTransaction]?.fee?.name || ''}
                            </p>
                        </div>
                        <div className="w-1/2">
                            <label className='text-xs block mb-2 text-opacity-40'>Item</label>
                            <p className="font-medium text-sm">{paymentsSelector?.payments?.payments[activeDialogTransaction]?.application?.applicationCode }</p>
                            <Link to={`/admin/applications/${paymentsSelector?.payments?.payments[activeDialogTransaction]?.application?._id}`}>
                                <button className='text-xs flex flex-row items-center gap-x-3 mt-1 text-vcm-purple hover:text-gray-400 transition duration-200'>See application details <ArrowIcon className={`w-5 h-5`} /></button> 
                            </Link>
                        </div>
                    </div>

                    <div className='w-full border-b border-secondary py-3'>
                        <label className='text-xs block mb-3 text-opacity-40'>Transaction initiated by</label>
                        <div className="w-full flex flex-row items-center gap-3">
                            <div className="p-2 rounded-md text-gray-500 inline-block">
                                <UserIcon  className="w-10 h-10"/>
                            </div>
                            <div>
                                <p className="text-sm mb-2 font-bold">{paymentsSelector?.payments?.payments[activeDialogTransaction]?.createdBy?.name}</p>
                                <p className="text-xs font-medium">{paymentsSelector?.payments?.payments[activeDialogTransaction]?.createdBy?.email}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </ModalDialog>}

            <ModalDialog
                shown={validatingPayment} 
                closeFunction={()=>{setValidatingPayment(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Manually Validate a Payment'
                maxWidthClass='max-w-lg'
                hideActions={true}
            >
                <ValidatePayment 
                    closeFunction={()=>(setValidatingPayment(false))}
                    reload={()=>{setReload(reload+1)}}
                />
            </ModalDialog>
        </>
    )
}

export default Payments